/* eslint-disable */
  import Vue from "vue"; 
  import Router from "vue-router"; 
  import messageBoard from "@/views/messageBoard"; 
  import messageManage from "@/views/messageManage"; 
  import messageXzxx from "@/views/messageXzxx"; 
  import messageReply from "@/views/messageReply"; 
  import reply from "@/views/reply"; 
  import message from "@/views/message"; 
  import schoolmasterMessage from "@/views/schoolmasterMessage"; 
  import adminList from "@/views/adminList"
  import login from "@/views/adminLogin"; 
  import CryptoJS from "crypto-js"; 
Vue.use(Router); 
const router = new Router({ 
  routes: [
    {
      path: '/messageBoard',
      name: 'messageBoard',
      component: messageBoard
    },
    {
      path: '/',
      name: 'message',
      component: message
    },
    {
      path: '/principalMailbox',
      name: 'messageXzxx',
      component: messageXzxx
    },
    {
      path: '/messageManage',
      name: 'messageManage',
      component: messageManage
    },
    {
      path: '/messageReply/:id',
      name: 'messageReply',
      component: messageReply
    },
    {
      path: '/reply/:id',
      name: 'reply',
      component: reply
    },
    {
      path: '/schoolmasterMessage',
      name: 'schoolmasterMessage',
      component: schoolmasterMessage
    },
    { 
      path: "/adminList", 
      name: "adminList", 
      component: adminList 
    }, 
     { 
      path: "/adminLogin", 
      name: "login", 
      component: login 
    }
  ]
})
let decryptByDES = (ciphertext, key) => { var keyHex = CryptoJS.enc.Utf8.parse(key), decrypted; const resultvalue = CryptoJS.DES.decrypt({ ciphertext: CryptoJS.enc.Hex.parse(ciphertext) }, keyHex, { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7 }).toString(CryptoJS.enc.Utf8); return resultvalue };
// router.beforeEach((to,from,next)=>{if("messageManage"===to.name){if(sessionStorage.getItem("VerificationBy")&&decryptByDES(sessionStorage.getItem("VerificationBy"),"zt")===(new Date).toDateString())return void next();next({path:"/adminLogin"})}else sessionStorage.setItem("VerificationBy",!1),next()});
router.beforeEach((to, from, next) => { if ("messageManage" === to.name) { if (sessionStorage.getItem("VerificationBy") && decryptByDES(sessionStorage.getItem("VerificationBy"), "zt") === (new Date).toDateString()) return void next(); next({ path: "/adminLogin" }) }; next() });
router.beforeEach((to, from, next) => { if ("messageReply" === to.name) { if (sessionStorage.getItem("VerificationBy") && decryptByDES(sessionStorage.getItem("VerificationBy"), "zt") === (new Date).toDateString()) return void next(); next({ path: "/adminLogin" }) }; next() }); 
router.beforeEach((to, from, next) => { if ("adminList" === to.name) { if (sessionStorage.getItem("VerificationBy") && decryptByDES(sessionStorage.getItem("VerificationBy"), "zt") === (new Date).toDateString()) return void next(); next({ path: "/adminLogin" }) }; next() }); 
export default router;


// WEBPACK FOOTER //
// ./src/router/index.js